import { getEndpoint } from 'common/backend/endpoints'
import axios from 'axios'

// Solo se necesita leer el payload (sin verificar firma): evita traer `jsonwebtoken`
// y sus polyfills de crypto (~270 KB) al bundle inicial.
const decodeJwtPayload = token => {
    try {
        const base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')
        const json = decodeURIComponent(
            atob(base64).split('').map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join('')
        )
        return JSON.parse(json)
    } catch (e) {
        return null
    }
}

export const getPublicCatalog = async token => {
    axios.interceptors.request.use(
        config => {
            config.headers['Authorization'] = token
            return config
        },
        error => {
            return Promise.reject(error)
        }
    )

    try {
        const { catalog_id } = decodeJwtPayload(token.replace('PUBLIC_TOKEN=', ''))
        const endpoint = getEndpoint('PRODUCTO')
        const res = await axios.get(endpoint + `/${catalog_id}?includesAllFilesAndMetadata=true&include_images=true&include_videos=true&published=true&estadoStock[]=Activo&estadoStock[]=Pronto en stock`)
        return { ...res?.data?.data }
    } catch (err) {
        throw { code: err?.response?.status }
    }
}

export default getPublicCatalog
